import React, { useMemo } from 'react';
import { useTable } from 'react-table';
import { useHiddenColumnsSetter } from '../../table/hooks/use-hidden-columns-setter';
import { getHiddenColumns } from '../../table/table-helpers/get-hidden-columns';
import { getRowId } from '../../table/table-helpers/get-row-id';
import { useAlerts } from '../../table/table-helpers/use-alerts';
import { useDecorators } from '../../table/table-helpers/use-decorators';
import { useExpandable } from '../../table/table-helpers/use-expandable';
import { useInfoIcons } from '../../table/table-helpers/use-info-icons';
import { useSelection } from '../../table/table-helpers/use-selection';
import { defaultSettingHooks } from './default-settings';
import { useDataGrid } from './use-data-grid';
const DEFAULT_PAGE_SIZE = 10;
export const useClientSideDataGrid = (params) => {
    const { columns, initialState, data, controlledState, selectable = false, alertIcon = undefined, infoIcons = undefined, tableOptions, expandable = false, isRowExpandable, layoutType = 'table', skipHiddenColumnsSetter, decorators } = params;
    const initial = useMemo(() => ({
        pageSize: DEFAULT_PAGE_SIZE,
        hiddenColumns: getHiddenColumns(columns),
        ...initialState
    }), [initialState, columns]);
    const tableInstance = useTable({
        columns,
        data,
        getRowId,
        initialState: initial,
        useControlledState: (state) => React.useMemo(() => ({
            ...state,
            ...controlledState
        }), [state, controlledState]),
        decorators,
        ...tableOptions
    }, ...defaultSettingHooks(layoutType), useAlerts(alertIcon), useInfoIcons(infoIcons), useExpandable(expandable, isRowExpandable), useSelection(selectable), 
    // must be the last hook to be able to decorate columns added by other hooks
    useDecorators);
    useHiddenColumnsSetter(columns, tableInstance, skipHiddenColumnsSetter);
    const dataGrid = useDataGrid(layoutType);
    return { tableInstance, dataGrid };
};
